import React from 'react';
import "../csscontainer/BulletList.css"; // <-- add this line

function BulletList({ points }) {
  // Check if the points array is valid and not empty
  if (!points || points.length === 0) {
    return null;
  }

  return (
    <ul className="dynamic-bullet-list">
      {points
        // Filter first: Remove any items that are null, undefined, or just whitespace/empty strings
        .filter((point) => point && point.trim() !== "")
        // Map second: Only create list items for valid points
        .map((point, index) => (
          <li key={index} className="bullet-item">
            {point}
          </li>
        ))}
    </ul>
  );
}

export default BulletList;